function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

// Provide a single global namespace for swatch related helpers.
window.FCTSwatchUtils = window.FCTSwatchUtils || {};

// Normalizes option values so matching works regardless of spacing/case.
if (typeof window.FCTSwatchUtils.normalizeOptionValue !== 'function') {
  window.FCTSwatchUtils.normalizeOptionValue = function normalizeOptionValue(value) {
    if (value === undefined || value === null) {
      return '';
    }
    return value.toString().trim().toLowerCase();
  };
}

// Finds a variant for the provided option combination, or null when missing.
if (typeof window.FCTSwatchUtils.findVariantByOptions !== 'function') {
  window.FCTSwatchUtils.findVariantByOptions = function findVariantByOptions(product, optionValues) {
    if (!product || !Array.isArray(product.variants) || !Array.isArray(optionValues)) {
      return null;
    }
    let normalize = window.FCTSwatchUtils.normalizeOptionValue;
    let normalizedOptions = optionValues.map(normalize);
    return product.variants.find(function (variant) {
      if (!variant) {
        return false;
      }

      // Support both Liquid payloads (variant.options) and /products/{handle}.js payloads (option1/2/3).
      let variantOptions = Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].filter(function (value) {
        return value !== undefined && value !== null;
      });
      if (!Array.isArray(variantOptions) || !variantOptions.length) {
        return false;
      }
      return normalizedOptions.every(function (targetValue, index) {
        if (!targetValue) {
          return true;
        }
        return normalize(variantOptions[index]) === targetValue;
      });
    }) || null;
  };
}

// Notify listeners once utilities are ready for use on first load.
if (!window.FCTSwatchUtils.ready) {
  window.FCTSwatchUtils.ready = true;
  document.dispatchEvent(new CustomEvent('fct:swatch-utils-ready'));
}

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card--featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener('mouseover', () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-card--featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        const finalizeCartClose = () => {
          panel.classList.remove('active');
          document.body.classList.remove('open-cc');
          document.body.classList.remove('open-cart');
          dispatchCustomEvent('cart-drawer:close');
        };
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            finalizeCartClose();
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                finalizeCartClose();
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            finalizeCartClose();
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');
      const isMobileLegacyQuickShop = panel && panel.classList.contains('mobile-legacy-quick-shop');
      const clearLegacyQuickShopState = () => {
        panel.classList.remove('mobile-legacy-quick-shop');
        document.body.classList.remove('open-quick-shop-legacy');
      };

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        document.body.classList.remove('open-quick-shop-legacy');
        if (isMobileLegacyQuickShop && panel.querySelector('#Product-Drawer-Content')) {
          panel.querySelector('#Product-Drawer-Content').innerHTML = '';
        } else {
          clearLegacyQuickShopState();
        }
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            clearLegacyQuickShopState();
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();
        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });
        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      const notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
      this.productCache = window.FCTQuickShopProductCache = window.FCTQuickShopProductCache || new Map();
      this.productRequestCache = window.FCTQuickShopProductRequestCache = window.FCTQuickShopProductRequestCache || new Map();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      const useLegacyMobileQuickShop = this.isMobileQuickShop() && this.isLegacyMobileQuickShopEnabled() && this.classList.contains('new-quick-shop-button');
      if (useLegacyMobileQuickShop) {
        this.enterLegacyMobileQuickShopMode();
        this.openMobileQuickShop(productHandle, href)
          .finally(() => {
            this.classList.remove('loading');
          });
        return;
      }
      this.exitLegacyMobileQuickShopMode();
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        })
        .catch(() => {
          this.classList.remove('loading');
        });
    }
    isMobileQuickShop() {
      return window.matchMedia('(max-width: 767px)').matches;
    }
    isLegacyMobileQuickShopEnabled() {
      return window.ShopData?.settings?.enable_mobile_legacy_quick_shop !== false;
    }
    enterLegacyMobileQuickShopMode() {
      this.drawer?.classList.add('mobile-legacy-quick-shop');
      this.body.classList.add('open-quick-shop-legacy');
    }
    exitLegacyMobileQuickShopMode() {
      this.drawer?.classList.remove('mobile-legacy-quick-shop');
      this.body.classList.remove('open-quick-shop-legacy');
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    openDrawer() {
      if (!this.drawer) return;
      this.body.classList.add('open-cc');
      this.body.classList.add('open-quick-view');
      this.drawer.classList.add('active');
      this.drawer.querySelector('.side-panel-close')?.focus();
    }
    getMobileQuickShopProduct(handle) {
      if (!handle) {
        return Promise.resolve(null);
      }
      if (this.productCache.has(handle)) {
        return Promise.resolve(this.productCache.get(handle));
      }
      if (this.productRequestCache.has(handle)) {
        return this.productRequestCache.get(handle);
      }

      const rootPath = String(theme.routes.root_url || '/').replace(/\/$/, '');
      const productUrl = `${rootPath}/products/${handle}.js`;
      const request = fetch(productUrl, {
        method: 'GET'
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Unable to load product');
          }
          return response.json();
        })
        .then((product) => {
          this.productCache.set(handle, product);
          this.productRequestCache.delete(handle);
          return product;
        })
        .catch((error) => {
          this.productRequestCache.delete(handle);
          throw error;
        });

      this.productRequestCache.set(handle, request);
      return request;
    }
    getOptionValues(product, optionIndex) {
      const key = `option${optionIndex + 1}`;
      const seen = new Set();
      const values = [];
      (product?.variants || []).forEach((variant) => {
        const value = this.normalizeOptionValue(variant?.[key]);
        if (!value || seen.has(value)) return;
        seen.add(value);
        values.push(value);
      });
      return values;
    }
    normalizeOptionName(option, index) {
      if (typeof option === 'string') return option;
      if (option && typeof option === 'object') {
        const candidate = option.name || option.option || option.title || option.label;
        if (candidate) return String(candidate);
      }
      return `Option ${index + 1}`;
    }
    normalizeOptionValue(value) {
      if (value === null || value === undefined) return '';
      if (typeof value === 'string' || typeof value === 'number') return String(value);
      if (value && typeof value === 'object') {
        const candidate = value.value || value.name || value.title || value.label;
        if (candidate !== undefined && candidate !== null) return String(candidate);
      }
      return String(value);
    }
    matchesSelection(variant, selected) {
      if (!variant || !Array.isArray(selected)) return false;
      for (let i = 0; i < selected.length; i += 1) {
        const selectedValue = selected[i];
        if (!selectedValue) continue;
        const variantValue = variant[`option${i + 1}`];
        if (variantValue !== selectedValue) {
          return false;
        }
      }
      return true;
    }
    getCurrentVariant(product, selected) {
      if (!product || !Array.isArray(selected)) return null;
      if (!selected.length || selected.some((value) => !value)) return null;
      return (product.variants || []).find((variant) => {
        return selected.every((value, index) => variant[`option${index + 1}`] === value);
      }) || null;
    }
    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && window.theme?.moneyFormat) {
        return Shopify.formatMoney(cents, window.theme.moneyFormat);
      }
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
    sizeSimplify(size) {
      const value = String(size || '').toLowerCase();
      if (value === 'xsmall') return 'XS';
      if (value === 'small') return 'S';
      if (value === 'medium') return 'M';
      if (value === 'large') return 'L';
      if (value === 'xlarge') return 'XL';
      if (value === '2xlarge') return '2XL';
      if (value === '3xlarge') return '3XL';
      if (value === '4xlarge') return '4XL';
      if (value === '5xlarge') return '5XL';
      return size;
    }
    escapeAttr(value) {
      return String(value || '').replace(/"/g, '&quot;');
    }
    openMobileQuickShop(productHandle, href) {
      return this.getMobileQuickShopProduct(productHandle)
        .then((product) => {
          if (!product || !this.drawer) return;

          this.enterLegacyMobileQuickShopMode();
          const content = this.drawer.querySelector('#Product-Drawer-Content');
          if (!content) return;

          const optionCount = Array.isArray(product.options) ? product.options.length : 0;
          const selected = new Array(optionCount).fill('');
          const variants = Array.isArray(product.variants) ? product.variants : [];

          if (variants.length === 1) {
            for (let i = 0; i < optionCount; i += 1) {
              selected[i] = variants[0][`option${i + 1}`] || '';
            }
          } else {
            for (let i = 0; i < optionCount; i += 1) {
              const values = this.getOptionValues(product, i);
              if (values.length === 1) {
                selected[i] = values[0];
              }
            }
          }

          const optionsHtml = (product.options || []).map((optionSource, index) => {
            const name = this.normalizeOptionName(optionSource, index);
            const values = this.getOptionValues(product, index);
            const optionNameSlug = String(name || '').replace(/\s+/g, '-').toLowerCase();
            const optionsBlockHtml = values.map((value) => {
              const normalizedValue = this.normalizeOptionValue(value);
              const valueSlug = String(normalizedValue || '').replace(/"/g, '').replace(/\s+/g, '-').toLowerCase();
              const optionId = `option-${optionNameSlug}-${valueSlug}-quick-shop`;
              return `
                <div class="option">
                  <input
                    id="${this.escapeAttr(optionId)}"
                    class="input-option"
                    autocomplete="off"
                    data-option-position="${index + 1}"
                    type="radio"
                    name="${this.escapeAttr(String(name || '').toLowerCase())}-quick-shop"
                    value="${this.escapeAttr(normalizedValue)}"
                  >
                  <label class="label-option" for="${this.escapeAttr(optionId)}">${this.sizeSimplify(normalizedValue)}</label>
                </div>
              `;
            }).join('');
            return `
              <div class="options-block">
                <label for="${this.escapeAttr(optionNameSlug)}" class="name-options">
                  Select ${name}
                  <span class="selected-option" data-selected-postion="${index + 1}"></span>
                </label>
                <div class="options option-count-${values.length}">
                  ${optionsBlockHtml}
                </div>
              </div>
            `;
          }).join('');

          content.innerHTML = `
            <div id="new-quick-shop-drawer" class="new-quick-shop-drawer is-open" data-product-handle="${this.escapeAttr(productHandle)}">
              <div class="new-quick-shop__head">
                <button type="button" class="new-quick-shop__close" aria-label="Close quick shop">×</button>
              </div>
              <div class="new-quick-shop__content">
                <div id="product-options-wrapper" class="product-options-wrapper">${optionsHtml}</div>
              </div>
            </div>
          `;

          const optionInputs = Array.from(content.querySelectorAll('#new-quick-shop-drawer .input-option'));
          const closeButton = content.querySelector('#new-quick-shop-drawer .new-quick-shop__close');
          let hasUserInteraction = false;

          if (closeButton) {
            closeButton.addEventListener('click', () => {
              dispatchCustomEvent('panel:close');
            });
          }

          const syncState = () => {
            const selectedLabels = Array.from(content.querySelectorAll('#new-quick-shop-drawer .selected-option'));
            selectedLabels.forEach((label, index) => {
              label.textContent = selected[index] || '';
            });

            optionInputs.forEach((input) => {
              const optionIndex = Number(input.dataset.optionPosition) - 1;
              const optionValue = input.value || '';
              const selectionForMatch = [...selected];
              selectionForMatch[optionIndex] = optionValue;
              const matchingVariants = variants.filter((variant) => this.matchesSelection(variant, selectionForMatch));
              const hasAvailableVariant = matchingVariants.some((variant) => variant.available);
              const optionEl = input.closest('.option');
              if (optionEl) {
                optionEl.classList.toggle('available', hasAvailableVariant);
                optionEl.classList.toggle('soldout', !hasAvailableVariant);
              }
              if (!hasAvailableVariant && input.checked) {
                input.checked = false;
                selected[optionIndex] = '';
              }
            });

            const currentVariant = this.getCurrentVariant(product, selected);
            const hasAllSelected = optionCount ? selected.every((value) => String(value || '').trim() !== '') : true;
            if (hasUserInteraction && hasAllSelected && currentVariant && currentVariant.available) {
              this.addMobileQuickShopToCart(currentVariant.id, null);
            }
          };

          optionInputs.forEach((input) => {
            input.addEventListener('change', () => {
              hasUserInteraction = true;
              const optionIndex = Number(input.dataset.optionPosition) - 1;
              selected[optionIndex] = input.checked ? input.value : '';
              syncState();
            });
          });

          syncState();
          this.openDrawer();

          dispatchCustomEvent('quick-view:open', {
            productUrl: href,
            productHandle: productHandle
          });
          addIdToRecentlyViewed(productHandle);
        })
        .catch(() => {});
    }
    addMobileQuickShopToCart(variantId, button) {
      if (!variantId) return;
      if (this.isAddingToCart) return;
      this.isAddingToCart = true;

      if (button) {
        button.disabled = true;
        button.classList.add('loading');
      }

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('sections', ['main-cart', 'cart-drawer', 'cart-bubble']);
      formData.append('sections_url', window.location.pathname);

      fetch(`${theme.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      })
        .then((response) => response.json())
        .then((response) => {
          if (response?.status) {
            return;
          }

          this.renderCartSections(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });

          if (this.drawer) {
            this.drawer.classList.remove('active');
          }
          this.body.classList.remove('open-quick-view');
          this.exitLegacyMobileQuickShopMode();

          const cartDrawer = document.getElementById('Cart-Drawer');
          if (cartDrawer) {
            this.body.classList.add('open-cc');
            this.body.classList.add('open-cart');
            cartDrawer.classList.add('active');
            cartDrawer.querySelector('.product-recommendations--full')?.classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          } else {
            this.body.classList.remove('open-cc');
          }
        })
        .finally(() => {
          this.isAddingToCart = false;
          if (button) {
            button.classList.remove('loading');
          }
        });
    }
    renderCartSections(parsedState) {
      const sections = parsedState && parsedState.sections ? parsedState.sections : null;
      if (!sections) return;
      [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }].forEach((section) => {
        const element = document.getElementById(section.id);
        if (!element || !sections[section.section]) return;
        const destination = element.querySelector(section.selector) || element;
        destination.innerHTML = this.getSectionInnerHTML(sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
      });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.exitLegacyMobileQuickShopMode();

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container')?.classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

/**
 * Keep drawer layout stable when mobile browser UI (like Safari tabs) changes viewport height.
 */
function setupVisualViewportDrawerFix() {
  const root = document.documentElement;
  const vv = window.visualViewport;

  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const isIOSDevice = /iP(hone|ad|od)/.test(platform) || /iP(hone|ad|od)/.test(ua);
  const isTouchMac = platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  const isIOS = isIOSDevice || isTouchMac;
  const isAndroid = /Android/i.test(ua);

  if (!isIOS && !isAndroid) return;
  if (isIOS) {
    root.classList.add('fct-ios');
  }
  if (isAndroid) {
    root.classList.add('fct-android');
  }

  let scheduled = false;

  function measureDrawer() {
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;

    const checkoutFooter = drawer.querySelector('.cart-drawer-footer');
    const footer = drawer.querySelector('.side-panel-footer');
    const footerHeight = checkoutFooter ? checkoutFooter.offsetHeight || 0 : (footer ? footer.offsetHeight || 0 : 0);
    const totalHeight = Math.round(footerHeight);
    root.style.setProperty('--cart-drawer-footer-height', `${totalHeight}px`);
  }

  function updateViewportVars() {
    scheduled = false;

    const height = vv?.height || window.innerHeight || 0;
    const offsetTop = vv?.offsetTop || 0;
    const bottomInset = Math.max(0, (window.innerHeight || height) - (height + offsetTop));
    const docClientHeight = document.documentElement.clientHeight || 0;
    const innerHeight = window.innerHeight || 0;
    const clientDelta = Math.max(0, innerHeight - docClientHeight);
    const fallbackInset = isIOS && bottomInset === 0 ? Math.max(clientDelta, 20) : 0;

    root.style.setProperty('--vvh', `${height}px`);
    root.style.setProperty('--vv-bottom', `${bottomInset}px`);
    root.style.setProperty('--ios-bottom-bar-fallback', `${fallbackInset}px`);

    measureDrawer();
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateViewportVars);
  }

  scheduleUpdate();

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
  document.addEventListener('cart-drawer:open', () => {
    // Wait a tick so the drawer DOM is fully rendered before measuring the footer.
    window.requestAnimationFrame(scheduleUpdate);
    root.classList.add('fct-ios-cart-open');
  });
  document.addEventListener('cart-drawer:close', () => {
    root.classList.remove('fct-ios-cart-open');
  });
  document.addEventListener('cart-drawer:updated', scheduleUpdate);

  const drawerObserver = new MutationObserver(() => {
    scheduleUpdate();
  });
  const drawer = document.getElementById('Cart-Drawer');
  if (drawer) {
    drawerObserver.observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  if (vv) {
    vv.addEventListener('resize', scheduleUpdate, { passive: true });
    vv.addEventListener('scroll', scheduleUpdate, { passive: true });
  }
}

/**
 * On mobile, prevent background page scroll while the cart drawer is open.
 */
function setupMobileCartDrawerScrollLock() {
  const root = document.documentElement;
  const body = document.body;
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  let lockedScrollY = 0;

  function isCartDrawerActive() {
    const drawer = document.getElementById('Cart-Drawer');
    return Boolean(drawer && drawer.classList.contains('active'));
  }

  function lockScroll() {
    if (!mobileQuery.matches) return;
    if (body.classList.contains('fct-lock-scroll')) return;

    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    root.classList.add('fct-lock-scroll');
    body.classList.add('fct-lock-scroll');
    body.style.top = `-${lockedScrollY}px`;
  }

  function unlockScroll() {
    if (!body.classList.contains('fct-lock-scroll')) return;

    root.classList.remove('fct-lock-scroll');
    body.classList.remove('fct-lock-scroll');
    body.style.top = '';
    window.scrollTo(0, lockedScrollY);
  }

  document.addEventListener('cart-drawer:open', lockScroll);
  document.addEventListener('cart-drawer:close', unlockScroll);

  mobileQuery.addEventListener('change', () => {
    if (!mobileQuery.matches) {
      unlockScroll();
      return;
    }
    if (isCartDrawerActive()) {
      lockScroll();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }

  setupVisualViewportDrawerFix();
  setupMobileCartDrawerScrollLock();
});
